import { createContext, type ReactNode, useContext } from 'react';

import type { AuthServices } from '../application/auth-services';

interface AuthServicesProviderProps {
  services: AuthServices;
  children: ReactNode;
}

const AuthServicesContext = createContext<AuthServices | null>(null);

export function AuthServicesProvider({ services, children }: AuthServicesProviderProps) {
  return <AuthServicesContext.Provider value={services}>{children}</AuthServicesContext.Provider>;
}

export function useAuthServices(): AuthServices {
  const services = useContext(AuthServicesContext);
  if (!services) throw new Error('AuthServicesProvider is missing');
  return services;
}
